module.exports = __webpack_public_path__ + "assets/img/bsre.76516ade.png";